import * as React from "react"
import { Link } from "gatsby"
import { LocaleLink } from "../../lib/IntlTools"
import T from "../T/T"
import { footerItems } from "../constants"
import "./styles.scss"

export default function Footer(props) {
    const { showReward, isProductPassportView } = props;

    return (
        <div className={`footer-container ${showReward ? 'claim' : ''}`}>

            {!isProductPassportView && (
                <div className="footer-menu-list">
                    {footerItems.map((item, index) => (!!item.isExternal ? (
                            <a key={index} className="uk-accordion-title" href={item.path} target='_blank'>
                                <T>{item.title}</T>
                            </a>
                        ) : (
                            <Link
                                key={index}
                                className="uk-accordion-title"
                                replace={true}
                                to={LocaleLink(`${item.path}`)}
                            >
                                <T>{item.title}</T>
                            </Link>
                        )
                    ))}
                </div>
            )
            }

            <div className="footer-text">
                <div className="copyright">
                    <span><T>footer-text</T></span>
                </div>
                <div className="powered-by">
                    <span><T>powered-by</T></span>
                    <a href="https://www.fabacus.com/" target="_blank">
                        <img src="/static/images/fabacus-logo.svg" alt=""/>
                    </a>
                </div>
            </div>
        </div>
    )
}
